/**
 * @generated SignedSource<<5c4550929640cd1a477699a981d41be5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobStates = "ACCEPTED" | "ASSIGNED" | "BLOCKED" | "BLOCKED_FAILED" | "BROKEN" | "CANCELED" | "CANCELING" | "EXPIRED" | "FINISHED" | "LIMITED" | "LIMITING" | "PENDING" | "RUNNING" | "SCHEDULED" | "SKIPPED" | "TIMED_OUT" | "TIMING_OUT" | "UNBLOCKED" | "UNBLOCKED_FAILED" | "WAITING" | "WAITING_FAILED" | "%future added value";
export type JobPrioritySearch = {
  number?: ReadonlyArray<number> | null;
};
export type JobConcurrencySearch = {
  group?: ReadonlyArray<string> | null;
};
export type JobsRefetchQuery$variables = {
  agentQueryRules?: ReadonlyArray<string> | null;
  clusterQueue?: ReadonlyArray<string> | null;
  concurrency?: JobConcurrencySearch | null;
  isMounted: boolean;
  organizationSlug: string;
  pageSize?: number | null;
  passed?: boolean | null;
  priority?: JobPrioritySearch | null;
  states?: ReadonlyArray<JobStates> | null;
};
export type JobsRefetchQuery$data = {
  readonly organization: {
    readonly " $fragmentSpreads": FragmentRefs<"Jobs_organization">;
  } | null;
};
export type JobsRefetchQuery = {
  response: JobsRefetchQuery$data;
  variables: JobsRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentQueryRules"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clusterQueue"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "concurrency"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMounted"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationSlug"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "passed"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priority"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "states"
},
v9 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "organizationSlug"
  }
],
v10 = {
  "kind": "Variable",
  "name": "agentQueryRules",
  "variableName": "agentQueryRules"
},
v11 = {
  "kind": "Variable",
  "name": "clusterQueue",
  "variableName": "clusterQueue"
},
v12 = {
  "kind": "Variable",
  "name": "concurrency",
  "variableName": "concurrency"
},
v13 = {
  "kind": "Variable",
  "name": "passed",
  "variableName": "passed"
},
v14 = {
  "kind": "Variable",
  "name": "priority",
  "variableName": "priority"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "args": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "kind": "Variable",
                "name": "isMounted",
                "variableName": "isMounted"
              },
              {
                "kind": "Variable",
                "name": "pageSize",
                "variableName": "pageSize"
              },
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states"
              }
            ],
            "kind": "FragmentSpread",
            "name": "Jobs_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "JobsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "condition": "isMounted",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "pageSize"
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "state",
                    "variableName": "states"
                  },
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "COMMAND"
                  }
                ],
                "concreteType": "JobConnection",
                "kind": "LinkedField",
                "name": "jobs",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "state",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "JobPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "agentQueryRules",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "passed",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "JobConcurrency",
                                "kind": "LinkedField",
                                "name": "concurrency",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "group",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "limit",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "label",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "command",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Build",
                                "kind": "LinkedField",
                                "name": "build",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Pipeline",
                                    "kind": "LinkedField",
                                    "name": "pipeline",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v16/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              }
                            ],
                            "type": "JobTypeCommand",
                            "abstractKey": null
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isJob"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5a134ccee31eee04f89269359476e3e2",
    "id": null,
    "metadata": {},
    "name": "JobsRefetchQuery",
    "operationKind": "query",
    "text": "query JobsRefetchQuery(\n  $organizationSlug: ID!\n  $isMounted: Boolean!\n  $priority: JobPrioritySearch\n  $agentQueryRules: [String!]\n  $clusterQueue: [ID!]\n  $concurrency: JobConcurrencySearch\n  $states: [JobStates!]\n  $passed: Boolean\n  $pageSize: Int\n) {\n  organization(slug: $organizationSlug) {\n    ...Jobs_organization_1TX77D\n    id\n  }\n}\n\nfragment JobLink_job on JobTypeCommand {\n  ...JobTitle_job\n  url\n}\n\nfragment JobTitle_job on JobTypeCommand {\n  label\n  command\n  build {\n    number\n    pipeline {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment Jobs_organization_1TX77D on Organization {\n  name\n  slug\n  jobs(first: $pageSize, type: COMMAND, state: $states, priority: $priority, agentQueryRules: $agentQueryRules, clusterQueue: $clusterQueue, concurrency: $concurrency, passed: $passed) @include(if: $isMounted) {\n    edges {\n      node {\n        __typename\n        ... on JobTypeCommand {\n          id\n        }\n        ...Row_job\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      hasNextPage\n    }\n  }\n}\n\nfragment Row_job on Job {\n  __isJob: __typename\n  ... on JobTypeCommand {\n    id\n    state\n    priority {\n      number\n    }\n    agentQueryRules\n    passed\n    concurrency {\n      group\n      limit\n    }\n    createdAt\n  }\n  ...JobLink_job\n}\n"
  }
};
})();

(node as any).hash = "caf377abddd1fc7702f6f0b72544089c";

export default node;
